import { render, staticRenderFns } from "./admin-shipping.vue?vue&type=template&id=5f14353c"
import script from "./admin-shipping.vue?vue&type=script&lang=js"
export * from "./admin-shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports